import { render, staticRenderFns } from "./SchoolOfParents.vue?vue&type=template&id=08a57fcc"
import script from "./SchoolOfParents.vue?vue&type=script&lang=js"
export * from "./SchoolOfParents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports